import React from 'react'

const Navbar = () => {
    return (
        <div className='flex justify-between items-center px-8 py-4 bg-gradient-to-r from-blue-900 to-blue-800 text-white shadow-lg w-[175vh]'>
            <div className='flex items-center gap-4'>
                <button className='p-2 hover:bg-blue-800 rounded-lg transition-colors duration-200'>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
                <div className='flex items-center gap-2'>
                    <div className='p-2 bg-blue-800 rounded-lg'>
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                    </div>
                    <span className='text-xl font-semibold'>Rach Power</span>
                </div>
            </div>

            <div className='flex items-center gap-4'>
                <div className='flex items-center gap-3 px-4 py-2 bg-blue-800/50 rounded-lg'>
                    <div className='relative'>
                        <img 
                            className='w-10 h-10 rounded-full border-2 border-blue-400 shadow-lg' 
                            src="https://ripl.org.in/TMS/img/boy.png" 
                            alt="Profile" 
                        />
                        <div className='absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-blue-800'></div>
                    </div>
                    <div className='flex flex-col'>
                        <span className='font-medium'>System Administrator</span>
                        <span className='text-sm text-blue-200'>Admin</span>
                    </div>
                </div>
                <button className='p-2 hover:bg-blue-800 rounded-lg transition-colors duration-200'>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Navbar
